var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9054_4765)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.1932,
    cy: 17.6863,
    r: 3.89031,
    fill: "#FB7401",
    stroke: "#FB7401",
    strokeWidth: 2.30053
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.1932,
    cy: 5.58722,
    r: 3.89031,
    fill: "white",
    stroke: "#91BDFA",
    strokeWidth: 2.30053
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.43536,
    cy: 17.6863,
    r: 3.89031,
    fill: "white",
    stroke: "#91BDFA",
    strokeWidth: 2.30053
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.43536,
    cy: 5.58722,
    r: 3.89031,
    fill: "white",
    stroke: "#91BDFA",
    strokeWidth: 2.30053
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9054_4765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9255,
    height: 23.9255,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard1);
export default __webpack_public_path__ + "static/media/Dashboard1.5bbffa983709e1d04dd010786ad59699.svg";
export { ForwardRef as ReactComponent };